export default {"src":"/_next/static/media/enrich-your-profile.4b2f8489.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};